import React, { useEffect } from 'react';

export default function RefreshToken({ currentAccessToken, setAccessToken, oauth }) {
    useEffect(() => {
        if (!currentAccessToken || !currentAccessToken.refreshToken) {
            return;
        }

        const delay = currentAccessToken.expiration - Date.now();
        const interval = setTimeout(() => {
            oauth.refreshAccessToken(currentAccessToken.refreshToken).then(response => {
                setAccessToken(response);
                return response;
            });
        }, delay);

        return () => clearTimeout(interval);
    }, [oauth, currentAccessToken, setAccessToken]);

    return null;
}
